import clsx from "clsx";

export interface StepDefinition {
  label: string;
}

interface StepIndicatorProps {
  totalSteps: number;
  currentIndex: number;
  highestVisitedIndex: number;
  onStepClick: (index: number) => void;
}

const StepIndicator = ({
  totalSteps,
  currentIndex,
  highestVisitedIndex,
  onStepClick,
}: StepIndicatorProps) => {
  return (
    <nav aria-label="Voortgang" className="flex items-center gap-1.5">
      {Array.from({ length: totalSteps }, (_, index) => {
        const isCompleted = index < currentIndex;
        const isCurrent = index === currentIndex;
        const isClickable =
          index <= highestVisitedIndex && index !== currentIndex;

        return (
          <button
            key={index}
            type="button"
            onClick={() => isClickable && onStepClick(index)}
            disabled={!isClickable}
            className={clsx(
              "h-2 rounded-full transition-all",
              isCurrent ? "w-6 bg-primary" : "w-2",
              isCompleted && "bg-primary/50",
              isCompleted && isClickable && "cursor-pointer hover:bg-primary/70",
              !isCompleted && !isCurrent && "bg-gray-200",
              !isClickable && !isCurrent && "cursor-default"
            )}
            aria-label={`Stap ${index + 1}`}
            aria-current={isCurrent ? "step" : undefined}
          />
        );
      })}
    </nav>
  );
};

export default StepIndicator;
